'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var angular = require('angular');

var scheduleViewComponent = exports.scheduleViewComponent = function () {

  /*@ngInject*/
  function scheduleViewComponent() {
    _classCallCheck(this, scheduleViewComponent);

    this.scheduleTypes = {
      'Three Panel MF': {
        class: 'col-xs-12 col-sm-6 col-lg-4',
        sections: [{ days: [1, 2, 3, 4, 5], title: 'Monday-Friday' }, { days: [6], title: 'Saturday' }, { days: [0], title: 'Sunday' }]
      },
      'Three Panel': {
        class: 'col-xs-12 col-sm-6 col-lg-4',
        sections: [{ days: [1, 2, 3, 4], title: 'Monday-Thursday' }, { days: [5], title: 'Friday' }, { days: [6, 0], title: 'Saturday-Sunday' }]
      },
      'Four Panel': {
        class: 'col-sm-6',
        sections: [{ days: [1, 2, 3, 4], title: 'Monday-Thursday' }, { days: [5], title: 'Friday' }, { days: [6], title: 'Saturday' }, { days: [0], title: 'Sunday' }]
      }
    };
    this.departing = ['BS', 'FI'];

    this.dayKey = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    this.message = 'World';
  }

  _createClass(scheduleViewComponent, [{
    key: 'deleteTime',
    value: function deleteTime(line, days) {
      this.removeTime({ line: line, days: days });
    }
  }, {
    key: 'dayCheck',
    value: function dayCheck(line, days) {
      var days1 = days.days;
      var days2 = line.days;
      if (days1.every(function (elem) {
        return days2.indexOf(elem) > -1;
      })) {
        return false;
      } else {
        return 'Only';
      }
    }
  }, {
    key: 'onlyDays',
    value: function onlyDays(line, days) {
      var days1 = days.days;
      var days2 = line.days;

      var out = '';

      for (var i = 0; i < days2.length; i++) {
        var day = days2[i];

        if (days1.indexOf(day) > -1) {
          var newDay = this.dayKey[day].charAt(0).toUpperCase() + this.dayKey[day].substr(1, 2).toLowerCase();

          if (out === '') {
            out = newDay;
          } else {
            out = out + ' & ' + newDay;
          }
        }
      }

      out = out + ' only';
      return out;
    }
  }]);

  return scheduleViewComponent;
}();

exports.default = angular.module('fiapiApp.scheduleView', []).component('scheduleView', {
  template: require('./scheduleView.pug'),
  bindings: { schedule: '<', removeTime: '&', mode: '@' },
  controller: scheduleViewComponent
}).name;


// WEBPACK FOOTER //
// ./client/components/scheduleView/scheduleView.component.js